
type WindowWithDataLayer = Window & {
    dataLayer: Record<string, any>[];
};

declare const window: WindowWithDataLayer;

export const aoFormSubmitGtmEvent = (accountType: string) => {
    window.dataLayer.push({
        event: 'ao_form_submission',
        aoFormAccountType:accountType     
    });
};